/* global $, Modernizr, API */

const $navigationCart = $('.js-navigation-cart');
const $navigationCartTotal = $('.js-navigation-cart-total');
const $navigationRemoveItem = $('.js-navigation-cart-remove');
const $navigationCartItemCount = $('.js-navigation-cart-item-count');

const BREAKPOINT = 992;

const navigationCart = {
  initialize() {
    if ($navigationCart.length) {
      this.createEvents();
    }
  },

  createEvents() {
    if (Modernizr.mq(`(min-width: ${BREAKPOINT}px)`)) {
      $navigationRemoveItem.on('click', (e) => {
        const $item = $(e.currentTarget).parents('.js-navigation-cart-item');

        this.removeItem($item);
      });
    }
  },

  removeItem($item) {
    const itemId = $item.data('item-id');
    const $cartItem = $(`.js-cart-item[data-id="${itemId}"]`);

    $.post(API.cartItemDestroy.replace(':id', itemId), {
      _method: 'DELETE',
    })
      .then(({ cartItemsCount }) => {
        $item.slideUp(500, () => {
          $item.remove();
        });

        if ($cartItem.length) {
          $cartItem.slideUp(500, () => {
            $cartItem.remove();
          });
        }

        this.outputCartItemsCount(cartItemsCount);
      });
  },

  outputSummary(meta) {
    $navigationCartTotal.text(meta.total_with_tax);
  },

  outputCartItemsCount(count) {
    $navigationCartItemCount.text(count);
  },
};

export default navigationCart;
